const zh = {
    monthArr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    noData: 'データなし',
    unit: {
        step: '歩',
        steps: '歩',
        day: '日',
        days: '日',
        time: '回',
        times: '回',
        km: 'キロ',
        hour: '時間',
        hours: '時間',
        kcal: '千カル',
    },
    dailyActive: {
        title: '日常の活動',
        tab0: '歩数',
        tab1: '運動エネルギー消費',
        unit0: '歩',
        unit1: '千カル',
        time0: '周',
        time1: '月',
        time2: '年',
        time3: '日',
        math0: '最高',
        math1: '平均',
        math2: '目標達成率',
        descTitle: '運動エネルギー消費',
        desc: '運動エネルギー消費とはスポーツ活動に従事する際に消費されるエネルギーのことで、活動のタイプ、時間、強度などに基づいて計算され、基礎代謝は含まれていない。（基礎代謝とは、生体の体温、心拍、呼吸、血液循環などの基本的な生命活動を維持するために必要な最低エネルギー代謝であり、1日のうち時間とともに蓄積される。）',
        target: '目標進捗',
        targetSet: '目標設定',
        targetDesc0: '目標達成まであと',
        targetDesc1: '歩、急いで動き出そう~',
        targetDesc2: 'kcal、急いで動き出そう~',
        weekTitle: '週間統計',
        weekRatio: '歩数',
        weekDesc0: '今週は',
        weekDesc1: '歩歩いて、標準的な運動場を',
        weekDesc2: '周歩いたことに相当します。',
        weekCalDesc0: '今週は',
        weekCalDesc1: ' kcalを消費しました。に相当',
        weekDay: '日平均',
        weekDayDesc0: '日平均歩数は前の週に比べて、',
        weekDayDesc2: '日平均歩数は前の週と同じです。',
        weekDayCalDesc0: '日平均運動エネルギー消費量は前の週と比較して、',
        weekDayCalDesc2: '日平均の運動エネルギー消費量は前の週と同じだった。',
        weekDayAdd: 'ぞうか',
        weekDayReduce: '減少',
        weekDayDesc1: '歩。',
        weekDayCalDesc1: 'Kcal。',
        monthTitle: '月次統計',
        monthTitleProp: '(今月のデータには本日は含まれていません）',
        monthDayDesc0: '今月は1日平均',
        monthDayDesc1: '歩歩きました、先月より',
        monthDayDesc2: '歩。',
        monthDayDesc3: '歩、先月と同じだ。',
        monthCalDayDesc0: '今月は1日平均',
        monthCalDayDesc1: ' kcalを消費しています、先月より',
        monthCalDayDesc2: 'Kcal。',
        monthCalDayDesc3: 'Kcal、先月と同じだ。',
        monthThis: '今月',
        monthLast: '先月',
        monthReach: '達成統計',
        monthReachDesc0: '今月の目標達成日数は前月比',
        monthReachDesc1: '日。',
        monthReachDesc2: '今月の目標達成日数は前月並み。',
        stepTargetTitle: '目標歩数',
        calTargetTitle: '目標カロリー',
        distance: 'きょり',
        cal: 'しょうひ',
        distanceUnit: '公里',
        calUnit: 'Kcal',
        abstract: 'アクティビティの概要',
        more: '詳細を表示',
        all: '合計歩数',
        weekReach: '目標達成日数',
        over: '目標は達成しました！続けて、あなたは活力と喜びを得ることができます！',
        and: '、',
        stepToDC0: '歩いたに等しい',
        stepToDC1: '周標準的な運動場を、消耗した',
        stepToDC2: '。',
        calTCal0: '消費することになります',
        allCal: '総消費量',
        noAbstract: 'データが不足しており、要約内容を示すことができません~',
    },
    abstract: {
        title: 'アクティビティの概要'
    },
    hr: {
        title: '心拍数',
        unit: '回/分',
        resting: '静止',
        time0: '日',
        time1: '周',
        time2: '月',
        time3: '年',
        math0: '最高',
        math1: '最小',
        math2: '平均心拍数',
        math3: '平均静止',
        descTitle: '静止心拍数',
        desc: '静止心拍数は朝起きる前の空腹心拍数であり、心臓の健康をはかる重要な指標の一つである。理想的な静止心拍数は50 ~ 80回/分であり、理想的な範囲内でない人は心血管疾患が発生する確率が高く、適切な強度の運動を行うことで静止心拍数を理想的にすることができる。',
        ecgTitle: '心电データ',
        ecgFrom0: '',
        ecgFrom1: '心電設備により採取',
        conclude: {
            "无有效结果": '有効な結果なし；',
            "未见明显异常": '明らかな異常なし；',
            "疑似房颤": '心房細動の疑い；',
            "疑似心动过速": '頻脈の疑い；',
            "疑似心动过缓": '徐脈の疑い；',
            "疑似长RR间期": '長いRR間隔の疑い；',
            "疑似偶发室性早搏": 'エピソード性心室性早期収縮の疑い；',
            "疑似频发室性早搏": '頻回の心室性期外拍動の疑い；',
            "疑似室性心动过速": '心室頻拍の疑い；',
            "疑似偶发室上性早搏": 'エピソード性上室性早拍の疑い；',
            "疑似频发室上性早搏": '頻回の上室性早拍の疑い；',
            "疑似室上性心动过速": '上室性頻拍の疑い；'
        }
    },
    hrDesc: {
        title: '不整脈',
        title0: '頻脈',
        desc0: '瞬時心拍数が毎分100回を超える割合。 頻脈には生理的頻脈と病的頻脈がある。 生理的頻脈は、ランニングや感情的興奮などの条件下で心拍数が加速するもので、高体温や貧血などの疾患によって引き起こされる頻脈は病的頻脈と呼ばれる。',
        title1: '徐脈',
        desc1: '瞬時心拍数が1分間に60回未満の割合。 徐脈にはいくつかのタイプがあるが、最も一般的なのは洞性徐脈である。 心拍数が毎分50回未満のほとんどは病的であり、通常は治療が必要である。',
        title2: '不整脈または早発性拍動',
        desc2: '洞性不整脈または早発性拍動を説明する。 心室性期外収縮や上室性期外収縮を含む期外収縮は、健常人や様々な心臓病患者を含む様々な人に起こる非常に一般的な臨床不整脈である。 1秒間に5回未満の早発は随時性、5回以上は頻発性に分類される。',
        title3: '上室性早期拍動',
        desc3: '上室性期外収縮は、洞結節の外側で発生する心房の早発性興奮であり、健常人にもあらゆる心臓病患者にもみられる一般的な不整脈である。 上室性期外収縮の頻度は年齢とともに増加する。 上室性早拍の主な症状は動悸と心臓が止まる感じです。 上室性早期拍動の頻度は、1分間に5回または1時間に30回以上です。',
        title4: '心室早期収縮',
        desc4: '早発性心室収縮は、心室から発生する心臓のリズムの障害であり、健常人にもさまざまな心臓病の患者にも起こる非常に一般的な不整脈である。 早発性心室収縮の頻度は、健常人では年齢とともに増加する。 心室性期外収縮の最も一般的な症状は動悸であり、時に患者は心前庭部のドキドキ感やめまいを経験する。 頻回の心室性期外収縮は1分間に5回以上、または1時間に30回以上である。',
        title5: '心房細動',
        desc5: '心房細動は最も一般的な持続性不整脈で、心拍数が速く不規則であることが特徴である。 心房細動の発症率は冠動脈疾患、高血圧、心不全などの心臓病と密接な関係があり、加齢とともに増加し（75歳以上では10％に達する）、脳卒中などの重篤な合併症を引き起こすことがある。',
        title6: '長いRR間隔',
        desc6: '長いRR間隔は、一般に心電図において1.5秒以上のRR間隔と定義され、外来心電図における重要なモニタリング指標の1つである。 長いRR間隔を引き起こす最も一般的な不整脈の種類は、主に心房細動または心房粗動、洞停止、房室ブロックである。',
    },
    ecgDesc: {
        title: '心臓の健康スコア',
        title0: '心臓の健康スコア',
        desc0: '心臓の健康スコアは、この心電図測定から算出されたリズム解析と不整脈イベントに従って計算され、一定の重み付け戦略に従って、不整脈イベントとリズム異常が少なければ心臓の健康スコアが高いことを意味し、その逆であれば、具体的なスコア制御は以下のようになる：',
        level0: '悪い：＜60',
        level1: '平凡：60-69',
        level2: '通常：70-79',
        level3: '良好：80-89',
        level4: 'より良い：≥90',
        title1: '結論と提言',
        desc1: '不整脈イベントやリズム異常に基づいて自動的に生成されたもので、臨床診断の直接の根拠となるものではありません。 危険性が示唆されたり、身体に違和感を覚えたりした場合は、速やかに通常の医療機関でカウンセリングや検査を受けることをお勧めします。'
    },
    hrvDesc: {
        title: 'HRV指標',
        title0: 'HRV指標',
        desc0: 'HRV指数とは心拍変動性のことで、心拍リズムの時間変化を意味し、各心拍周期の微妙な時間変化とその規則性を分析するために用いられ、主に心臓の自律神経調節機能を反映する。 HRVが高ければ高いほど、神経による循環器系の調節機能が優れていることを意味する。 HRVが悪い場合は、安静と感情のコントロールに注意し、心臓の不快感などの問題がある場合は、適時に医師に相談して検査を受けてください。具体的なスコアは以下のように比較される：',
        level0: '悪い：0-21',
        level1: '真ん中：21-34',
        level2: 'むしょうに：34-47',
        level3: 'より良い：>47',
    },
    sleep: {
        title: '睡眠',
        time0: '日',
        time1: '周',
        time2: '月',
        fallAsleep: '眠り始める',
        wakeUp: '目を覚ます',
        level0: 'より良い',
        level1: '真ん中',
        level2: 'とは異なる',
        hour: ' 時 ',
        minute: ' 分',
        sleepStage: '睡眠段階',
        stage0: 'しみん',
        stage1: '浅い眠り',
        stage2: '急速眼球運動',
        stage3: '意識的',
        mathTitle: '睡眠統計',
        math0: '平均睡眠時間',
        math1: '最短睡眠時間',
        math2: '最長睡眠時間',
        ratioLevel0: '深い眠りの割合（参考值：20~60%）',
        ratioLevel1: '浅い眠りの割合（参考值：＜55%）',
        ratioLevel2: 'ファストアイの割合（参考值：10~30%）',
        ratioLevel3: '覚醒回数（参考値：≦1回）',
        ratioNormal: '正常',
        ratioHigh: 'は高め',
        ratioLow: 'あまる',
        sportLevel: '運動強度',
        other: '睡眠のすすめ',
        stageTitle: '期間別統計',
        stageKey0: '深い睡眠の平均時間',
        stageKey1: '軽い睡眠の平均時間',
        stageKey2: '平均急速眼球運動持続時間',
        stageKey3: '平均覚醒時間',
        fallTitle: '就寝時間',
        dayTitle: '1日平均統計',
        averageDesc0: '今週の1日平均睡眠時間と先週の比較',
        averageDesc1: '今月の1日平均睡眠時間と先月の比較',
        averageDesc2: '上昇',
        averageDesc3: '減少',
        averageDesc5: 'フラットに保つ。',
        averageDesc4: '。',
        averageDesc6: '',
        averageDesc7: '',
        scoreTitle: '睡眠スコア',
    },
    sleepStage: {
        title: '睡眠段階',
        desc0: '睡眠段階は、脳波や生理的な症状から研究の便宜上、人為的に区切られたものであり、実際には明確な線引きは困難である。 様々な睡眠段階は徐々に変化し、重なり合い、絡み合い、それぞれに重点が置かれる傾向がある。 人間の睡眠では、一晩に約4～6回の睡眠サイクルがあり、それらは互いに関連し合いながら毎週繰り返される。 心身の健康を維持するために、毎日十分な睡眠を確保することは非常に有益であり、研究によると、成人の適切な睡眠時間：6-10時間、睡眠時間は睡眠の質の唯一の基準ではなく、長時間の睡眠は必ずしも睡眠不足を補うものではなく、時には質の高い睡眠を得るために助長されていない、我々は睡眠の質を向上させるために仕事と休息時間を確保する必要があります。',
        title1: '深い眠りの段階',
        desc1: '脳波の周波数が著しく低下し、呼吸数と血圧も著しく低下し、脳が十分な休息を得ることができ、深い眠りの段階で目が覚めると、めまい、動悸、イライラなどの症状が現れる。深い眠りが長ければ長いほど、睡眠の質は向上するが、深い眠りが長すぎると、特定の病気の発症のシグナルかもしれないので、専門の医師に相談することをお勧めする。',
        title2: '浅い眠り段階',
        desc2: '脳波が遅くなり、心拍数と呼吸速度が遅くなり、人は眠りに入ったが目覚めやすくなり、浅い眠りは正常な現象であり、急速な目覚めに役立つが、浅い眠りの割合が大きすぎると、睡眠の質が保証されず、眠気が出やすくなる。',
        title3: 'レム期',
        desc3: '人間の眼球は急速に前後に動くが、その段階で人は通常、夢の中にいる。夢の中で人が動きをしないように、筋肉は弛緩した麻痺状態にある。',
        title4: '明晰期',
        desc4: '夜間の覚醒は本当の覚醒ではなく、人は自分が覚醒していることに気づかないことがあり、覚醒の臨界状態では、通常、覚醒時間の合計は睡眠時間の合計の10％未満である。',
    },
    bos: {
        title: '血中酸素飽和度',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '正常',
        level1: '軽度低酸素症',
        level2: '中等度低酸素症',
        descTitle: '血中酸素飽和度',
        desc0: '血中酸素飽和度（SaO2）とは、血液中の酸素結合ヘモグロビン（HbO2）の体積が、結合可能な全ヘモグロビンの体積に占める割合、すなわち血液中の酸素濃度のことで、呼吸サイクルの重要な生理的パラメータである。',
        desc1: '酸素値の結果は、95～100パーセント正常、90～94パーセント軽度低酸素、70～89パーセント中等度低酸素。',
        desc2: '本機能はあくまでも参考であり、医学的診断の根拠として使用するものではありません。 体調不良を感じた場合は、直ちに医療機関にご相談ください。'
    },
    pressure: {
        title: '肉体的ストレス',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: 'は高め',
        level1: 'は中程度',
        level2: 'は普通',
        level3: 'ほぐす',
        descTitle: '肉体的ストレス',
        desc0: 'このデバイスは、HRV（心拍変動）などのデータをもとに、アルゴリズムによって現在の負担圧力値を導き出す。 ストレス値によって、自分の体のストレス状態を把握することができ、ストレスが高まっているときは、タイムリーにストレスを軽減することが健康に役立つ。',
        desc1: '圧力結果の説明：1～29はリラックス、30～59は普通、60～79は中程度、80～99は高め'
    },
    fitnessAge: {
        title: '体力年齢',
        time0: '周',
        time1: '月',
        unit: '歳',
        actualAge: '実年齢',
        math0: '最高',
        math1: '最低',
        descTitle: '体力年齢',
        desc: '体力年齢は最大酸素摂取量から導き出される。 一般的に、VO2maxが高いほど有酸素運動能力が高い。'
    },
    staminaLevel: {
        title: 'フィットネスレベル',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '初学者',
        level1: 'スポーツ初心者',
        level2: 'チャレンジャー',
        level3: 'アスリート',
        level4: 'スポーツファン',
        level5: 'スポーツ・マニア',
        level6: 'エリートアスリート',
        unit0: 'フィットネスレベル',
        unit1: '有酸素',
        unit2: '無酸素',
        descTitle: 'フィットネスレベル',
        desc0: 'フィットネスレベルは、最適なパフォーマンスの可能性を示す複合指標である。 エアロビック・フィットネス・レベルは、中・長距離のパフォーマンスを行う能力を判断するために使用することができ、一方、無酸素フィットネス・レベルは、短・中距離のパフォーマンスを行う能力を判断するために使用することができる。',
        desc1: '体力レベル値は、10-19.9ビギナー、20-29.9スポーツ・ノービス、30-39.9チャレンジャー、40-49.9アスリート、50-59.9スポーツ・エンスージアスト、60-69.9スポーツ・エンスージアスト、70-80.9エリート・アスリートと表現される。'
    },
    trainingLoad: {
        title: '短期負荷',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '低い',
        level1: '最適な',
        level2: '高い',
        descTitle: '短期負荷',
        desc0: 'トレーニング負荷は、現在の身体的負荷のレベルを反映することができ、運動前に現在のトレーニングの強度と時間を調整することで、最適なトレーニングスケジュールを実現し、怪我のリスクを軽減することができます。',
        desc1: '短期負荷値の説明：',
        desc2: '＜0.8 低負荷；',
        desc3: '0.8-1.5 負荷は最適だ；',
        desc4: '＞1.5 負荷が高い。'
    },
    trainingStatus: {
        title: 'トレーニングステート',
        time0: '周',
        time1: '月',
        level0: '無状態期間',
        level1: 'オーバートレーニング期間',
        level2: '訓練期間の停止',
        level3: '後退期間',
        level4: '維持期間',
        level5: 'リカバリ期間',
        level6: '進歩期',
        level7: 'デクレメント期間',
        descTitle: 'トレーニングステート',
        desc0: 'トレーニング状況とは、ランニングやサイクリングのトレーニング状況を評価する指標です。 過去7日間のトレーニング負荷や筋力レベルの推移を観察することで、その後の運動トレーニングの指針を得ることができます。',
        desc1: '無状態期間：過去7日間訓練なしまたは最初の訓練から7日未満',
        desc2: 'オーバートレーニング期間：トレーニング負荷を低減し、回復時間を増加することを提案する',
        desc3: '訓練期間の停止：訓練を開始して順方向の訓練適応を達成することを提案する',
        desc4: '後退期：訓練計画を点検し、訓練負荷を調整することを提案する',
        desc5: '維持期間：訓練負荷を高めて順方向の訓練適応を達成することを提案する',
        desc6: '回復期：体力レベルの低下を避けるために訓練負荷を適切に増加することを提案する',
        desc7: '進歩期：現在の訓練状態を維持することを提案する',
        desc8: '減量期間：トレーニング負荷を微調整するために、体力レベルの変化に注目することをお勧めします',
    },
    vo2max: {
        title: '最大酸素摂取量',
        time0: '周',
        time1: '月',
        level0: '悪い',
        level1: 'ふりょう',
        level2: '標準',
        level3: 'よい',
        level4: 'ずば抜けている',
        level5: 'トップ',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '最大酸素摂取量',
        desc: '最大酸素摂取量は、激しい運動中に身体が酸素を吸収・利用する最高速度と定義できる。 個人の心肺体力を表すのによく使われる。',
        age: '(ねんれい'
    },
    lactate: {
        title: '乳酸閾値',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '乳酸閾値',
        unit0: 'キロ',
        unit1: '回/分',
        type0: 'ペースとは',
        type1: '心拍数',
        desc0: '乳酸閾値ペースとは、運動中に身体が耐えられる乳酸濃度（最大心拍数の約88～92％）での最速のランニングペース。',
        desc1: '最大乳酸定常状態(MLSS)は運動中に到達する。 乳酸閾値心拍数はこの段階で発生し、一般的に最大心拍数の88～92%に該当し、この心拍数を下回ると運動強度は長時間疲労することなく運動を継続できることを示す。'
    },
    forecast: {
        title: 'ランニング成績予測',
        title0: '最新の成績',
        level2: '半馬',
        level3: '全馬',
        title1: '最高の成績',
        descTitle: 'ランニング成績予測',
        desc: 'ユーザーの体力レベルの状態に基づいて、個人が異なる距離を走っている間に達成できる最高の成績を推定し、長い間にランニングの成績が向上したことを監視します。',
        prot: '日付'
    },
    basicHr: {
        title: '基礎心拍数',
        time0: '周',
        time1: '月',
        unit: '回/分',
        math0: '最大心拍数',
        math1: '最低心拍数',
        math2: '平均基礎',
        descTitle: '基礎心拍数',
        desc: '基礎心拍数とは、早朝起床前の空腹時の心拍数のことで、心臓の健康状態を示す最も重要な指標のひとつである。 理想的な基礎心拍数は毎分50～80拍で、この範囲にない人は心血管系疾患の可能性が高く、適切な強度で運動することで基礎心拍数を理想的な値にすることができる。'
    },
    sportType: {
        其他: 'その他',
        全部运动: 'すべて',
        健走: 'ウォーキング',
        跑步: '走る',
        骑行: '自転車に乗る',
        室内游泳: '屋内水泳',
        户外游泳: '水泳',
        操场跑: 'グラウンド走り',
        徒步越野: 'トレッキング',
        徒步穿越: 'トレッキング',
        马拉松: 'マラソン',
        铁人三项: 'トライアスロン',
        深蹲: '深蹲',
        划船机: '划船机',
        椭圆机: '椭圆机',
        卷腹: '卷腹',
        自由训练: '自由訓練',
        跳绳: '跳绳',
        俯卧撑: '腕立て伏せ',
        平板支撑: '平板支撑',
        室内跑: '室内走り',
        射箭: 'アーチェリー',
        拳击: 'ボクシング',
        爬楼: 'ビル登り',
        越野跑: 'トレイルランニング',
        登山: '登山',
        轮滑: 'ローラースケート',
        骑马: '乗馬',
        皮划艇: '皮划艇',
        冲浪: '冲浪',
        帆板: '帆板',
        越野骑行: 'オフロードサイクリング',
        越野滑雪: 'クロスカントリースキー',
        滑雪登山: 'スキー登山',
        室内攀岩: '室内クライミング',
        户外攀岩: '室内クライミング',
        飞盘: 'フリスビー',
        跳伞: 'スカイダイビング',
        篮球: 'バスケットボール',
        足球: 'サッカー',
        网球: 'サッカー',
        羽毛球: 'バドミントン',
        乒乓球: 'テーブルテニス',
        力量训练: '力量训练',
    },
    challengeType: {
        type: 'シングルプレーヤー競争',
        attribute0: {
            name: 'タイムトライアル',
            attribute: 'タイムトライアル',
            desc0: 'チャレンジサイクルの中で、運動距離は最大',
            desc1: 'まで累積され、運動時間が短いほどランキングは高くなります。 (運動後、データを同期してください。ランキングはリアルタイムで更新されます）'
        },
        attribute1: {
            name: '距離競争',
            attribute: '距離競争',
            desc: 'チャレンジサイクル内では、運動の累積距離が長いほどランキングが高くなります。 (キャンペーン終了後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute1骑行: {
            name: 'サイクリングに挑戦',
            attribute: '距離競争',
            desc: 'チャレンジサイクル中の累積走行距離が長いほど、ランキングは高くなります。 (走行後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute1跑步: {
            name: 'ランニングに挑戦',
            attribute: '距離競争',
            desc: 'チャレンジサイクル内では、ランの累積距離が長いほどランキングが高くなります。 (走った後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute2: {
            name: '脂肪燃焼コンテスト',
            attribute: '脂肪燃焼コンテスト',
            desc: 'チャレンジ期間中、指定された運動で消費したカロリーが多ければ多いほどランキングが上がります。 (運動後にデータを同期してください。リーダーボードはリアルタイムで更新されます)'
        },
        attribute3: {
            name: 'スピードウェイ・レース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中、1レースの平均速度が速いほどランキングは高くなります。(トレーニング後にデータを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute3骑行: {
            name: '自転車スピードレース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中の1回のライドの平均速度が速いほど、ランキングは高くなります。(ライド後にデータを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute3跑步: {
            name: 'ランニング・スピードレース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中、1回のランの平均ペースが速いほどランキングは高くなります。(走った後にデータを同期してください。リーダーボードはリアルタイムで更新されます)'
        },
        attribute4: {
            name: 'ステップチャレンジ',
            type: 'シングルプレーヤー競争',
            desc: '歩数が多いほどランキングは上位になります（運動後にデータを同期してください。ランキングリストはリアルタイムで更新されます）。',
        }
    },
    challengeList: {
        title: '困難に立ち向かう',
        history: '歴史',
        join: '参加者数'
    },
    challengeDesc: {
        medalPop: '優勝おめでとう！',
        accept: '受け入れる',
        over: 'クローズド',
        no0: '',
        no1: '位',
        end0: '終了まであと',
        end1: '日',
        rDistance0: '残距離',
        distanceUnit: 'キロ',
        tDistance: '総距離',
        race: '最速ペース',
        cal: '総脂肪燃焼量',
        calUnit: 'kcal',
        step: '総歩数',
        stepUnit: '歩',
        down: 'ドロップダウン',
        up: 'プルアップ',
        range: 'チャレンジサイクル',
        type: '類型論',
        typeValue: 'シングルプレーヤー競争',
        attribute: 'チャレンジ属性',
        attributeArr: ['タイムトライアル', '距離競争', '脂肪燃焼コンテスト', 'スピードウェイ・レース', 'シングルプレーヤー競争'],
        sport: '運動タイプ',
        tab0: '詳細',
        tab1: 'ランキング',
        descTitle: '説明',
        top3: 'ベスト3勲章',
        medalFinish: '今回の挑戦を勝ち取ったのは',
        noMedal: '勲章をもらっていないので、次は頑張ってね~',
        joining: '今すぐ参加',
        tableTitle0: '順位',
        tableTitle1: 'ユーザー',
        tableTitle2: 'ざんりゅうきょり',
        tableTitle3: '時間を使う',
        tableTitle4: 'ぜんきょり',
        tableTitle5: '総脂肪燃焼量',
        tableTitle6: '最速ペース',
        tableTitle7: '総歩数',
        join: '参加者数'
    },
    sportRecord: {
        title: '運動記録',
        record0: {
            name: '歩数',
            record0: '1日の最多歩数記録(歩)',
            record1: '1週間の最大記録数(歩)',
            record2: '単月最多記録(歩)'
        },
        record1: {
            name: '走る',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: 'さいてきはいそくど',
        },
        record2: {
            name: '乗る',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: 'さいてきはいそくど',
        },
        record3: {
            name: '泳ぐ',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: '最適なSWOLF',
        },
        record4: {
            name: '登山',
            record0: 'シングル最大高さ(メートル)',
        }
    },
    sportCount: {
        title: '運動統計',
        time0: '周',
        time1: '月',
        unit0: 'キロ',
        unit1: '分',
        item1: '運動回数',
        item1Unit: '回',
        item2: '運動時間',
        item2Unit: '時間',
        item3: 'ぜんきょり',
        item4: '運動エネルギー消費',
        item4Unit: 'kcal',
    },
    newSportList: {
        title: 'モーションレポート',
        type0: '運動週報',
        type1: '運動月報',
        type2: '運動年報',
    },
    newWeek: {
        title: '運動週報',
        step: '歩',
        day: '日',
        stepDesc0: '今週、あなたは人口の',
        stepDesc1: '以上を歩いた',
        time: '回',
        km: 'キロ',
        hour: '時間',
        kcal: 'kcal',
    },
    newMonth: {
        title: '運動月報',
        step: '歩',
        steps: '歩',
        day: '日',
        days: '日',
        time: '回',
        times: '回',
        km: 'キロ',
        hour: '時間',
        hours: '時間',
        kcal: 'kcal',
        noMedal: '勲章は追加されていないので、来月頑張ります~',
        add0: '新たに',
        add1: '個',
        more0: '',
        more1: 'を超える人'
    },
    newWeekHistory: {
        title: '歴史週報',
        no: '下にはないよ~'
    },
    newMonthHistory: {
        title: '歴史月報',
        no: '下にはないよ~'
    },
    feedback: {
        title: '意見のフィードバック',
        prop: 'あなたが直面している問題を説明したり、最適化の提案をしたりしてください。私たちは必ず真剣に対応します！',
        contact: '連絡先',
        contactValue: '携帯電話番号/QQ/ウィーチャット/メールボックス',
        submit: '送信'
    },
    medal: {
        title: '私の勲章',
        tab0: '運動勲章',
        tab1: '北斗勲章',
        tab2: 'チャレンジ勲章',
        get0: '勲章を',
        get1: '個受章した',
        step: '歩く',
        run: 'ランニング',
        ride: 'に乗る',
        swim: 'スイミング',
        climb: '山に登る',
        marathon: 'マラソン',
        sport: '運動'
    },
    selectCityApp: {
        title: 'としせんたく',
        current: '現在の都市'
    },
    prodInstructions: {
        title: '操作の説明',
        video: '操作ビデオ',
        desc: '詳細な説明',
        quick: 'クイックスタートガイド',
        question: 'よくある質問',
        compass: '羅針盤の検査は正しくありませんか？',
        compass700: '羅針盤の検査は正しくありませんか？',
        sleep: '時計を正常に装着しても睡眠データはありません？',
        height: '標高が悪い？',
        ecg: '心電が測定できない/結果が正確ではない？',
        android: 'Android携帯電話のメッセージは時計にプッシュできませんか？',
        ios: 'iOSの携帯電話のメッセージは時計にプッシュできませんか？',
        keepAlive: 'どのようにして保活設定を行いますか？',
        restricted: '携帯電話のオープン権限プロンプト「制限された設定」？',
        map: '地図をダウンロードする方法は？'
    },
    keepAlive: {
        title: '保活設定',
        desc: 'Aswearがバックグラウンドで正常に動作し、Bluetooth接続が安定していることを保証するために、ユーザーは以下の対応機種を参照して設定することができます。',
        tabArr: ['xiaomi', 'ファーウェイ', 'vivo', 'OPPO', 'ワン・プラス', 'realme', 'Honor', 'レノボ', 'MEIZU', 'サムスン'],
        xiaomi: {
            p0: '1 xiaomi',
            p1: '1.1 小米携帯電話でバックグラウンド活動を許可',
            p2: '設定]-[電話設定]-[アプリケーション設定]-[アプリケーション管理]-[Aswear]-[省電力ポリシー]-[無制限]に設定するをタップします。',
            p3: '1.1.1 アプリケーション設定',
            p4: '1.1.2 アプリケーション管理',
            p5: '1.1.3 Aswear',
            p6: '1.1.4 省電力ポリシー',
            p7: '1.1.5 無制限',
            p8: '1.2 小米携帯電話の自動起動権限設定',
            p9: '設定]-[電話設定]-[アプリケーション設定]-[アプリケーション管理]-[アスウェア]-[セルフスタート]-[セルフスタート]を有効にする]をタップします。',
            p10: '1.2.1 アプリケーション設定',
            p11: '1.2.2 アプリケーション管理',
            p12: '1.2.3 Aswear',
            p13: '1.2.4 自己始動スイッチを入れる',
            p14: '1.3 バックグラウンドタスクのロック',
            p15: '①下を長押しして上にスワイプすると、バックグラウンドタスクが表示されます；',
            p16: '②Aswear」アプリを長押しし、「ロック」アイコンをタップしてアプリをロックする。'
        },
        huawei: {
            p0: '2 ファーウェイ',
            p1: '2.1 ファーウェイ携帯ロックバックグラウンドタスク',
            p2: '画面下部から上にスライド-マルチタスクページに移動-Aswearを見つける-Aswearを下にスライド-Aswearをロックします。',
            p3: '2.2 ファーウェイ携帯電話はバックグラウンド活動を許可',
            p4: '「設定」→「携帯電話の設定」→「アプリケーションとサービス」→「アプリケーション起動管理」→「Aswear」をクリックして、「自己起動を許可」と「バックグラウンド活動を許可」のスイッチをオンにします。',
            p5: '2.2.1 アプリケーションとサービス',
            p6: '2.2.2 アプリケーション起動管理',
            p7: '2.2.3 Aswear',
            p8: '2.2.4 自己起動を許可',
            p9: '2.2.5 [OK]をクリックします'
        },
        vivo: {
            p0: '3 vivo',
            p1: '3.1 vivo携帯電話でバックグラウンド活動を許可',
            p2: '「設定」→「携帯電話設定」→「バッテリ」→「バックグラウンド高消費電力」→「Aswear」をクリックして、「バックグラウンド高消費電力」をオンにします。',
            p3: '3.1.1 バッテリ',
            p4: '3.1.2 バックグラウンド高消費電力',
            p5: '3.1.3 Aswear',
            p6: '3.1.4 バックグラウンドの高消費電力をオンにする',
            p7: '3.2 vivo携帯電話の自己起動権限設定',
            p8: '「設定」→「携帯電話設定」→「アプリケーションと権限」→「権限管理」→「自己起動」→「Aswear」をクリックして、「自己起動」をオンにします。',
            p9: '3.2.1 適用と権限',
            p10: '3.2.2 権限管理',
            p11: '3.2.3 自己起動',
            p12: '3.2.4 Aswearスイッチをオンにする'
        },
        oppo: {
            p0: '4 OPPO',
            p1: '4.1 OPPO携帯電話でバックグラウンド活動を許可',
            p2: '設定→【バッテリ】→【消費電力管理の適用】→【Aswear】をクリックして、【完全なバックグラウンド動作を許可】→ポップアップ設定【許可】をオンにします。',
            p3: '4.1.1 バッテリ',
            p4: '4.1.2 消費電力管理の適用',
            p5: '4.1.3 Aswear',
            p6: '4.1.4 完全なバックグラウンド動作を許可',
            p7: '4.1.5 クリック許可',
            p8: '4.2 OPPO携帯電話の自己起動権限設定',
            p9: '「設定」→「携帯電話の設定」→「アプリケーション管理」→「自己起動管理」→「Aswear」→「バックグラウンド自己起動」をオンにします。',
            p10: '4.2.1 アプリケーション管理',
            p11: '4.2.2 自己起動管理',
            p12: '4.2.3 Aswearスイッチをオンにする'
        },
        yijia: {
            p0: '5 ワン・プラス',
            p1: '5.1 携帯電話によるバックグラウンドタスクのロック',
            p2: '画面下部から上にスライド-マルチタスクページに進む-Aswearを見つける-詳細ボタンをクリック-Aswearをロックするをクリックします。',
            p3: '5.2 携帯電話1台でバックグラウンド活動を許可',
            p4: '設定→【携帯電話の設定】→【バッテリ】→【消費電力管理の適用】→【Aswear】をクリックして、【完全なバックグラウンド動作を許可】→【許可】に設定します。',
            p5: '5.2.1 バッテリ',
            p6: '5.2.2 消費電力管理の適用',
            p7: '5.2.3 Aswear',
            p8: '5.2.4 完全なバックグラウンド動作を許可',
            p9: '5.2.5 クリック許可',
            p10: '5.3 携帯電話の自動起動権限設定の追加',
            p11: '設定→【携帯電話の設定】→【アプリケーション管理】→【自己起動管理】→【Aswear】→【バックグラウンド自己起動】をクリックします。',
            p12: '5.3.1 アプリケーション管理',
            p13: '5.3.2 自己起動管理',
            p14: '5.3.3 Aswear'
        },
        realme: {
            p0: '6 realme',
            p1: '6.1 realme携帯ロックバックグラウンドタスク',
            p2: '画面下部から上にスライド-マルチタスクページに進む-Aswearを見つける-詳細ボタンをクリック-Aswearをロックするをクリックします。',
            p3: '6.2 realme携帯電話によるバックグラウンド活動の許可',
            p4: '設定→【携帯電話の設定】→【バッテリ】→【消費電力管理の適用】→【Aswear】をクリックして、【完全なバックグラウンド動作を許可】→【許可】に設定します。',
            p5: '6.2.1 バッテリ',
            p6: '6.2.2 消費電力管理の適用',
            p7: '6.2.3 Aswear',
            p8: '6.2.4 完全なバックグラウンド動作を許可',
            p9: '6.2.5 クリック許可',
            p10: '6.3 realme携帯電話の自己起動権限設定',
            p11: '設定→【携帯電話の設定】→【アプリケーション管理】→【自己起動管理】→【Aswear】→【バックグラウンド自己起動】をクリックします。',
            p12: '6.3.1 アプリケーション管理',
            p13: '6.3.2 自己起動管理',
            p14: '6.3.3 Aswear'
        },
        rongyao: {
            p0: '7 Honor',
            p1: '7.1 Honor携帯電話のバックグラウンドタスクをロックする',
            p2: '画面下から上にスワイプ - マルチタスクページに移動 - Aswearを探す - Aswearを下にスワイプ - Aswearをロック。',
            p3: '7.2 Honor携帯電話のバックグラウンド活動を許可する',
            p4: '設定]-[電話設定]-[アプリとサービス]-[アプリ起動管理]-[Aswear]をタップし、[自己起動を許可]と[バックグラウンド動作を許可]のスイッチをオンにします。',
            p5: '7.2.1 アプリとサービス',
            p6: '7.2.2 アプリ起動管理',
            p7: '7.2.3 Aswear',
            p8: '7.2.4 バックグラウンド動作を許可',
            p9: '7.2.5 OKをクリック'
        },
        lianxiang: {
            p0: '8 レノボ',
            p1: '8.1 レノボ携帯でバックグラウンド活動を許可',
            p2: '設定]-[電話設定]-[アプリと通知]-[特別なアプリの許可]-[バッテリーの最適化]-[Aswear]をタップし、ポップアップウィンドウで[最適化しない]を選択し、[完了]をタップします。',
            p3: '8.1.1 アプリと通知',
            p4: '8.1.2 特別なアプリの許可',
            p5: '8.1.3 バッテリーの最適化',
            p6: '8.1.4 Aswear',
            p7: '8.1.5 最適化しない選択',
            p8: '8.1.6 クリックして完了',
            p9: '8.2 レノボ携帯電話のセルフブート許可設定',
            p10: '設定]-[電話設定]-[アプリと通知]-[すべてのアプリを表示]-[Aswear]-[アクセス許可]-[アプリの自己起動]をタップし、ポップアップウィンドウで[許可]を選択し、[完了]をクリックします。',
            p11: '8.2.1 アプリと通知',
            p12: '8.2.2 すべてのアプリを表示',
            p13: '8.2.3 Aswear',
            p14: '8.2.4 アクセス許可',
            p15: '8.2.5 アプリの自己起動',
            p16: '8.2.6 許可'
        },
        meizu: {
            p0: '9 MEIZU',
            p1: '9.1 Meizuの携帯電話でバックグラウンド活動を許可する',
            p2: '設定]-[電話設定]-[プライバシーとアクセス許可]-[バックグラウンド管理]-[Aswrar]をタップし、[バックグラウンド実行を許可]を選択します。',
            p3: '9.1.1 プライバシーとアクセス許可',
            p4: '9.1.2 バックグラウンド管理',
            p5: '9.1.3 Aswear',
            p6: '9.1.4 バックグラウンド実行を許可',
            p7: '9.2 Meizu携帯電話のバックグラウンドタスクをロックする',
            p8: '画面下部から上にスワイプ - マルチタスクページに移動 - Aswearを探す - Aswearを下にスワイプ - Aswearをタップしてロックする。'
        },
        sanxing: {
            p0: '10 サムスン',
            p1: '10.1 サムスン携帯電話のロックバックグラウンドタスク',
            p2: '画面下から上にスワイプ - マルチタスクページに移動 - Aswearを探す - Aswearを長押し - タップしてAswearをロックする。',
            p3: '10.2 サムスン携帯、バックグラウンド活動を許可',
            p4: '設定]-[電話設定]-[アプリ]-[Aswear]-[バッテリー]をタップし、[バックグラウンド動作を許可]をオンにします。',
            p5: '10.2.1 アプリ',
            p6: '10.2.2 Aswear',
            p7: '10.2.3 バッテリー',
            p8: '10.2.4 バックグラウンド動作を許可',
            p9: '10.3 サムスン携帯電話のセルフブート許可設定',
            p10: '設定]-[電話設定]-[一般管理]-[バッテリー]-[バックグラウンド使用制限]-[自動的に実行されるアプリ]-[Aswear]-[バックグラウンドアクティビティの許可]をタップします。',
            p11: '10.3.1 一般管理',
            p12: '10.3.2 バッテリー',
            p13: '10.3.3 バックグラウンド使用制限',
            p14: '10.3.4 自動的に実行されるアプリ',
            p15: '10.3.5 バックグラウンドアクティビティの許可',
            p16: '【より多くの知識】',
            p17: '携帯電話でアクセス許可を開くと「制限された設定」が表示される問題の解決策'
        }
    },
    androidMessageSet: {
        title: 'Android携帯のメッセージが時計にプッシュされない？',
        p0: 'メッセージプッシュの原則：',
        p1: '時計がアンドロイド携帯電話に接続されると、システムは携帯電話の通知バーから通知を取得し、時計にプッシュします。',
        p2: '対応するアプリケーションメッセージが腕時計に受信されていないことに気づいた場合は、ウィーチャットを例にして、次の操作を試してみてください。',
        p3: '',
        p4: '',
        p5: '',
        p6: '',
        p7: '1.携帯電話の設定に入り、「権限管理＞右上コーナー＞特殊アクセス権限＞使用権の通知＞Aswear APP」を検索して入力します。',
        p8: '',
        p8end: '',
        p9: '2.「AswearAPP>マイデバイス>メッセージリマインダ」で、メッセージをプッシュするアプリケーションスイッチをオンにします。',
        p10: '',
        p11: '',
        p12: '3.携帯電話の通知欄に情報が表示されることを確認する：ここではHarmonyOS 3.0携帯電話を例にして、「設定＞通知とステータス欄」を選択し、通知が必要なアプリケーションをクリックし、通知を許可するように設定し、そのアプリケーションの各カテゴリのメッセージの通知方式（着信音、振動、バナー、ロック画面通知、邪魔を許可、またはデスクトップアイコンの角標など）を設定し、サイレント通知スイッチをオフにする。',
        p13: '',
        p14: '',
        p15: '',
        p16: '',
        p17: '',
        p18: '',
        p19: '①通知とステータスバーに入る②対応アプリケーションの通知スイッチを入れる（ウィーチャットを例にした）',
        p20: '',
        p21: '',
        p22: '③許可通知スイッチをオンにする④その他の種別のメッセージ通知設定（新しいメッセージ通知を例に：許可通知と邪魔を許可し、サイレント通知をオフにする）。',
        p23: '',
        p24: '',
        p25: '',
        p26: '',
        p27: '',
        p28: '',
        p29: '',
        p31: '4.微信メッセージがプッシュされないか、情報の詳細が表示されない場合は、微信をオンにし、「マイ>設定>新メッセージリマインダ」を選択し、新メッセージ通知の受信とメッセージの詳細表示を通知するスイッチをオンにし、微信メッセージの内容が携帯電話のステータスバーに正常に表示されることを確認します。',
        p32: '',
        p33: '',
        p34: '',
        p35: '',
        p36: '',
        p37: '',
        p38: '①新規メッセージ通知に入る②メッセージ詳細とメッセージ通知を表示する通知スイッチを入れる',
        p39: '',
        p40: '',
        p41: '',
        p42: '',
        p43: '',
        p44: '',
        p45: '*WeChatコンピュータ版にログインする場合は、WeChatの携帯電話の静音機能がオフになっていることを確認してください：携帯電話の端にあるWeChatのトップページでバナー通知をクリックしてから、携帯電話を静音にして、このボタンを灰色にします。',
        p46: '',
        p47: '',
        p48: '',
        p49: '',
        p50: '',
        p51: '',
        p52: '5.携帯電話にAswear APPを保護されたバックグラウンドアプリケーションとして設定し、携帯電話を再起動することを強くお勧めします。設定すると、メッセージ送信の安定性が向上します。設定方法はアプリ保活設定を参考にして、ジャンプをクリックしてください。',
        p53: '6.時計と携帯電話を再起動してみてください。',
        p54: '7.問題が残っている場合は、腕時計とAswear APPを最新バージョンにアップグレードし、接続を再ペアリングします。',
        p55: '*Aswear APPの更新：微信公式アカウント“北斗卫星手表” -> 探-非凡 -> APP下载、インタフェースのガイドラインに従ってダウンロードします。',
        p56: '腕時計：Aswear APP>マイデバイス>ファームウェアアップデート。'
    },
    iosMessageSet: {
        title: 'IOS携帯電話のメッセージは腕時計にプッシュできない？',
        p0: 'メッセージプッシュの原理：',
        p1: '腕時計がiOS携帯に接続されると、iOSシステムは携帯電話の通知欄の通知を取得し、あなたの腕時計にプッシュします。',
        p2: '3.対応するアプリケーションメッセージが腕時計に受信されていないことに気づいた場合は、ウィーチャットを例にして、次の操作を試してみてください。',
        p3: '',
        p4: '',
        p5: '',
        p6: '',
        p7: '携帯電話システム応用通知設定が正常であることを確保する：「携帯電話設定＞通知＞ウィーチャット＞許可通知スイッチをオンにする＞ロック画面、通知センター、バナーをチェックする」、プレビュー選択を常に表示し、バナースタイル選択を継続します。',
        p8: '',
        p9: '',
        p10: '',
        p11: '',
        p12: '',
        p13: '',
        p14: '',
        p15: '',
        p16: '',
        p17: '',
        p18: '①設定通知に入る②Aswearを見つける。',
        p19: '',
        p20: '',
        p21: '',
        p22: '',
        p23: '③通知許可スイッチをオンにする④ロック画面、通知センター、バナーをチェックする。',
        p24: '',
        p25: '',
        p26: '',
        p27: '',
        p28: '⑤プレビュー選択常時⑥バナースタイル選択継続を表示する。',
        p29: '',
        p30: '',
        p31: '',
        p32: '',
        p33: '',
        p34: '',
        p35: '',
        p36: '',
        p37: '2.腕時計との共有通知設定が正常であることを確認する：携帯電話での設定＞Bluetooth＞ペアリングされたデバイスをクリック＞共有システム通知を開く。',
        p38: '',
        p39: '',
        p40: '',
        p41: '',
        p42: '①Bluetoothの設定に進む②ペアリングされた設定をクリックする③共有通知を開きます。',
        p43: '',
        p44: '',
        p45: '2.Aswearメッセージがプッシュされない場合は、アプリケーションAPPを開き、「マイ」>「マイデバイス」>「デバイス情報」>「メッセージ・リマインダ」を選択し、対応するメッセージ・タイプ通知スイッチを開きます。',
        p46: '',
        p47: '',
        p48: '',
        p49: '',
        p50: '①私の②ペアリングされたデバイスを選択する③メッセージアラームに入る④対応するメッセージタイプ通知スイッチをオンにする。',
        p51: '',
        p52: '',
        p53: '',
        p54: '',
        p55: '',
        p56: '',
        p57: '',
        p58: '',
        p59: '4.時計と携帯電話を再起動してみてください。',
        p60: '5.問題が残っている場合は、腕時計とAswearAPPを最新バージョンにアップグレードし、接続を再ペアリングします。',
        p61: '',
        p62: '',
        p63: '* Aswear APP更新：',
        p64: 'App StoreでAswear APPを検索し、インタフェースの指示に従ってダウンロード更新を行います。',
        p65: '*腕時計の更新経路：',
        p66: 'Aswear APP -> マイ -> マイデバイス -> デバイス情報 -> ファームウェアアップデート。',
        p67: '*ペアリング接続時に携帯電話システムがポップアップしてiPhone通知を表示できますか？許可をクリックします。',
        p68: '',
        p69: '',
        p70: '',
        p71: 'もし上記の方法があなたの問題を解決していないか、操作中に困難に遭遇した場合は、店舗のカスタマーサービスに連絡してください。私たちは心からあなたのためにサービスします。あなたの生活が楽しいことを祈ります。',
        p72: '1.腕時計との共有通知設定が正常であることを確認する：携帯電話での設定＞Bluetooth＞ペアリングされたデバイスをクリック＞共有システム通知を開く。',
        p73: '',
        p74: '',
        p75: '',
        p76: '',
        p77: '①Bluetoothの設定に進む②ペアリングされた設定をクリックする③共有通知を開く',
        p78: '',
        p79: '腕時計が携帯電話に出られない？（TA 700 S/G腕時計モデル向け）',
        p80: 'まず、時計と携帯電話が正常に接続されていることを確認し、次の操作を試みます。',
        p81: '①携帯電話の設定＞Bluetooth、接続されているデバイスを見つけ、デバイスをクリックします。',
        p82: '',
        p83: '',
        p84: '②再ロードが完了すると、接続済みステータスが表示され、右側の感嘆符をクリックして詳細ページに進み、デバイスタイプが別であることを確認します。',
        p85: '',
        p86: '',
        p87: '',
        p88: '',
        p89: '',
        p90: '',
        p91: '',
        p92: ''
    },
    problemType: {
        title: 'よくある質問',
        model: '型番'
    },
    problemList: {
        title: 'よくある質問',
        model: '型番',
        all: 'みんなが聞いている質問',
        zhibeizhen: '羅針盤の検査は正しくありませんか？',
        haiba: '標高が悪い？',
        android: 'Android携帯電話のメッセージは時計にプッシュできませんか？',
        ios: 'iOSの携帯電話のメッセージは時計にプッシュできませんか？',
        keepAlive: 'どのようにして保活設定を行いますか？',
        prompt: '携帯電話のオープン権限プロンプト「制限された設定」？',
        instructions: '操作の説明',
        sleep: '時計を正常に装着しても睡眠データはありません？',
        map: '地図をダウンロードする方法は？',
        ecg: '心電が測定できない/結果が正確ではない？'
    },
    privacyAgreement: {
        title: 'プライバシー契約',
        p0: '本契約はAswearAPP（開発者：成都天奥電子株式会社）に適用される',
        p1: '北斗時計は成都天奥電子株式会社（以下「私たち」または「天奥電子」と略称する）が運営するアウトドアスポーツとスマート健康監視を提供するシリーズ製品とサービスで、製品は主にスマート時計で、サービスは主にAndroid、IOS、Windowsプラットフォーム下の関連アプリと微信公衆番号が提供する関連サービスなどを含む。',
        p2: '天奥電子の製品とサービスを使用することにより、お客様は本プライバシーポリシーに記載されているすべての条項をお読みになり、承認し、受け入れたことを示します。これには、デルがいつでも行うことができる変更が含まれています。デルは、お客様の所在地のデータ保護に関する法律を含む法律を使用して、個人情報のプライバシー、機密、セキュリティを保護することを約束しています。同時に、私たちの従業員と代理店全員がこれらの義務を履行することを約束します。',
        p3: 'この声明に疑問や意見がある場合は、カスタマーサービスホットライン：028-87559999を通じてお問い合わせください。1ヶ月以内にお返事します。',
        p4: '一、個人情報の収集と使用方法',
        p5: '個人情報とは、電子的または他の方法で記録された、単独でまたは他の情報と結合して特定の自然人の身元を識別したり、特定の自然人の活動状況に反応したりすることができる様々な情報を指す。',
        p6: '個人機密情報とは、身分証明書番号、個人生物識別情報、銀行口座番号、財産情報、行方軌跡、取引情報などを含む。',
        p7: '私たちは、この声明に記載されている以下の目的だけで、あなたの個人情報を収集して使用します。',
        p8: '1、アカウント登録',
        p9: '私たちは携帯電話番号、QQ、または微信を私たちのアカウントシステムとして使用しています。携帯電話番号を使用してログインすると、アカウントバインディング用の認証コードが取得されます。QQまたはWeChat関連を使用してログインすると、QQまたはWeChatのユニークなID、アイコン、ニックネームが収集されます。これらの情報を収集することは、ログイン情報を保存するために使用され、異なるデバイスを使用してログインするときにデータを同期させ、アカウントのセキュリティを保護することができます。その中で携帯電話番号は個人の機密情報であり、使用範囲を厳格に制限し、秘密にすることを約束します。このような情報を提供しないと、私たちが提供するサービスを正常に使用できない可能性があります。',
        p10: 'なぜあなたの運動と健康データを管理するのか、私たちはあなたの性別、体重、身長、誕生日などを含むあなたのアカウントデータを使用する必要があります。性別、体重、身長、誕生日を使用するのはあなたにより良い健康アドバイスを提供するためです。',
        p11: 'アカウントデータを作成または変更すると、自動的に携帯電話のローカルに保存され、バックグラウンドサーバに同期されます。',
        p12: 'デバイスやアプリケーションにログインアカウント機能がなければ、このようなデータは記録されません。一部の製品はアカウントにログインしていないと、オンラインサービスを提供できません。ログイン後に性別や体重などの情報を提供しないと、提案の正確性に影響を与える可能性があります。',
        p13: 'アカウントをログアウトしたい場合は、APPにログインして、「マイ」ページにアクセスして、「設定」欄をクリックして、「その他の設定」ページにアクセスして、「アカウントとセキュリティ」欄を選択して、「アカウントをログアウト」をクリックして、アカウントをログアウトした後、アカウントと関連情報を永久に削除します。',
        p14: '2、設備管理',
        p15: '北斗の腕時計を管理するためには、腕時計デバイス識別子（MAC、SNなど）、デバイスタイプ、デバイス構成パラメータなどを含むデバイス情報とネットワーク情報を収集する必要があります。このような情報を収集する目的は、Bluetooth接続を確立し、デバイス構成情報を管理し、ソフトウェアのアップグレードを完了し、データソースを表示することです。ネットワーク情報には、IPアドレス、ネットワークタイプ、ネットワーク接続状態などが含まれており、これらのデータは私たちの製品のネットワーク接続体験を向上させるために使用されます。',
        p16: '接続デバイスには携帯電話のBluetoothアクセス権が必要ですが、関連情報は保存されません。デルのウェアラブルデバイスは、アプリケーションを介して管理する際に、個人情報やデバイス構成情報を専用のセキュリティチャネルを介してウェアラブルappアプリケーションに転送します。',
        p17: 'このような情報を提供しないと、デルのウェアラブルデバイスや関連するバックグラウンドサービスを使用できないか、一部の機能が制限されています。',
        p18: '3、個人健康情報管理',
        p19: '心電収集機能を備えた設備とサービスの中で、あなたの健康データを記録し管理するために、私たちはあなたの運動設定データ（運動状態、心博総数、心率区間などを含む）を収集する必要があり、心率データは運動心率、日常心率及び心率データ分析を経て生成されたオンライン報告に分けられ、心率データは個人敏感情報に属し、このような情報を収集する目的は健康関連データの測定、記録、表示及び心電データ分析の正確性を増加し、私たちの製品のサービス品質を向上させるためである。',
        p20: 'このような情報を提供しないと、私たちのappアプリケーションの機能が制限され、通常のサービスを提供できなくなります。',
        p21: '4、運動データ記録',
        p22: '運動記録と統計機能を備えた設備とサービスでは、あなたの運動データを記録し管理するために、私たちはあなたの設備の位置、運動軌跡、運動タイプ、運動時間の長さ、ランニング姿勢、歩数、距離、高さ、運動心拍数などを収集する必要があります。運動タイプには、健走、ランニング、サイクリング、登山、水泳、マラソンなどがあります。位置と軌跡は個人の機密情報であり、このような情報を収集する目的は、APPで運動軌跡の表示機能を提供するために、日常の運動データを記録し、統計することです。',
        p23: '私たちはappアプリケーションで関連する運動データを統計して表示します。データを他の用途として使用する場合、匿名化処理を行った後も表示されます。',
        p24: 'このような情報を提供しない場合は、運動状況の統計、分析、表示を提供することはできません。',
        p25: '5、授権同意を得る例外',
        p26: '次の場合、天奥電子は個人情報を収集し、使用するために承認を得る必要はありません:',
        p27: '（1）国家の安全、国防の安全に関する；',
        p28: '（2）公共の安全、公共衛生、重大な公共利益に関連する；',
        p29: '（3）犯罪捜査、起訴、裁判、判決執行などに関連する；',
        p30: '（4）個人情報の主体やその他の個人の生命、財産などの重大な合法的権益を守るために本人の同意を得にくい場合；',
        p31: '（5）収集された個人情報は、個人情報の主体が自ら社会に公開したものである；',
        p32: '（6）合法的に公開された情報の中から収集された個人情報、例えば合法的な新聞報道、政府情報公開などのルート；',
        p33: '（7）ご要望に応じて契約を締結するために必要な；',
        p34: '（8）提供される製品および／またはサービスの安全で安定した運用を維持するために必要な、例えば製品および／またはサービスの障害の発見、処置；',
        p35: '（9）合法的な報道に必要な；',
        p36: '（10）学術研究機関が公共の利益に基づいて統計や学術研究に必要であり、かつ対外的に学術研究や記述の結果を提供する場合、結果に含まれる個人情報を非標識化処理する；',
        p37: '（11）法律法規に規定されたその他の状況。',
        p105: 'アカウント登録時にデバイスの一意のデバイス識別コード（IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIMカードIMSI情報など）を取得し、デバイス管理と認証に使用し、ユーザー登録の安全性を保証し、パスワード漏洩が他のデバイスによって異郷登録されることを防止する必要がある。',
        p38: '二、個人情報の処理、共有、譲渡、公開を依頼する方法',
        p39: '1、委託処理',
        p40: '特別な場合には、お客様の個人情報を処理するために他社の代表者に依頼する可能性があります。デルは、本声明に従って、個人情報を処理するために関連する秘密保護およびセキュリティ対策を講じるために、委託先と厳格な秘密保護契約または個人情報処理条項に署名します。',
        p41: '2、共有＃キョウユウ＃',
        p42: '共有とは、私たちが他の個人情報制御者に個人情報を提供し、双方がそれぞれ個人情報に対して独立した制御権を持つ過程を指す。私たちはあなたの個人情報を対外的に共有することはありませんが、以下の場合を除く：',
        p43: '（1）明示的な同意を得た場合の共有：明示的な同意を得た後、指定した第三者に承認範囲内の情報を共有します；',
        p44: '（2）法定状況下での共有：私たちは法律法規の規定、訴訟紛争の解決需要に基づいて、あるいは行政、司法機関が法に基づいて提出した要求に基づいて、対外的にあなたの個人情報を共有することができます；',
        p45: '3、譲渡とは',
        p46: '譲渡とは、個人情報制御権を私たちが別の個人情報制御者に移転する過程を指す。私たちはあなたの個人情報を会社、組織、個人に譲渡することはありませんが、以下の場合を除く：',
        p47: '（1）明確な同意を得た場合の譲渡：あなたの明確な同意を得た後、私たちは他の方にあなたの個人情報を譲渡します；',
        p48: '（2）合併、買収、または破産清算に関連する場合、個人情報の譲渡に関連する場合は、新たに個人情報を保有する企業、組織に対して引き続き本声明の制約を受ける必要があります。そうしないと、当社、組織に対してライセンス同意を求める必要があります。',
        p49: '4、公開',
        p50: '私たちは以下の場合にのみ、あなたの個人情報を公開します：',
        p51: '（1）あなたの明確な同意を得てから；',
        p52: '（2）法的根拠または合理的根拠に基づく開示：法的、法的手続き、訴訟、または公的および政府の主管部門から要求がある場合には、情報を開示することがあります；',
        p53: '5、個人情報の共有、譲渡、公開時事における事前承認の例外',
        p54: '以下の場合、個人情報の共有、譲渡、公開は事前に承認を得る必要はありません：',
        p55: '（1）国家の安全、国防の安全に関する；',
        p56: '（2）公共の安全、公共衛生、重大な公共利益に関連する；',
        p57: '（3）犯罪捜査、起訴、裁判、判決執行などに関連する；',
        p58: '（4）個人情報の主体やその他の個人の生命、財産などの重大な合法的権益を守るために本人の同意を得にくい場合；',
        p59: '（5）あなた自身が公開している個人情報；',
        p60: '（6）合法的に公開された情報の中から収集された個人情報、例えば合法的な新聞報道、政府情報公開などのルート；',
        p106: '6、マイクライセンスに基づく拡張機能',
        p107: 'スマート文字盤、音声アシスタントなどの音声対話機能を実現するために、システムのマイク権限をオンにすることを選択できます。スマート音声テクノロジーの使用中に入力した音声情報を機械認識、オンラインインタラクション、ニーズに合わせて収集します。この機能はシステム権限でオフにすることができ、オフにするとオンライン音声対話機能を実装できなくなる可能性がありますが、他の基本的な機能を楽しむことには影響しません。',
        p61: '三、データ主体の権利',
        p62: 'デルの製品/サービスを使用している間は、個人情報にアクセス、訂正、削除することができます。また、個人情報の使用に対する同意を撤回する権利を保障します：',
        p63: '1. 個人情報の取得；',
        p64: '2. 個人情報の削除を要求；',
        p65: '3. 個人情報の更新を要求；',
        p66: '4. お客様の個人情報を使用する権利の撤回。',
        p67: '四、データ保管場所と期間',
        p68: '1、保管場所',
        p69: '本サービスで収集・生成された個人情報は、中華人民共和国内に格納されます。',
        p70: '2、保管期間',
        p71: '目的を達成するために必要な時間だけ個人情報を保持し、前述の保存時間を超えた後に個人情報を削除または匿名化して処理します。',
        p72: 'データセキュリティのために、あなたのデータはあなたのアカウントとバインドされ、あなたの心の電気、運動などの健康データは私たちのバックグラウンドサーバに保存され、あなた自身がデータを削除したり、アプリケーションアカウントを削除したりするまで、あなたのデータは同時に安全に削除されます。',
        p73: 'また、製品やサービスが停止した場合は、プッシュ通知、公告などの形式で通知し、合理的な期限内に個人情報を削除したり、匿名化したりします。',
        p74: '五、サードパーティが収集した情報',
        p75: 'デルが提供するサービスには、デルのサービスプロバイダに属するサードパーティ追跡ツールが含まれている可能性があります。このサードパーティは、Cookies、APIs（アプリケーションプログラミングインタフェース）、SDKs（ソフトウェアプログラム開発パッケージ）を使用して、デルを代表してユーザー情報を収集し、分析することができます。サードパーティは、お客様のデバイス識別子、MAC（メディアアクセス制御）アドレス、IMEI（モバイルデバイス国際IDコード）、地域（特定の言語を使用する場所）、地理的位置情報、IPアドレスなどの情報にアクセスし、それぞれのプライバシーポリシーの下でサービスを提供することを目的としています。デルのプライバシーポリシーは、サードパーティ追跡ツールの使用をカバーしません。これらの第三者にアクセスしたり、制御したりする権限はありません。',
        p76: '六、ユーザーのソフトウェアインストールリストを取得する',
        p77: 'アプリは携帯電話にインストールされているアプリストアのリストを取得します。この機能は各アプリケーションストアへの展示やジャンプにのみ使用され、ユーザーがアプリケーションを評価したり、コミュニケーションしたりするのに便利です。これらのアプリケーションストアにアクセスしたり制御したりする権限はありません。第三者のアプリケーションストアに個人情報を送信する権限もありません。',
        p78: '統合SDKサービスと権限の使用方法の説明',
        p79: '（1）友盟+SDK',
        p80: '当社の製品は友盟+SDKを統合しており、プログラムがあなたのデバイスMacアドレス、ユニークデバイス識別コード（IMEI/android ID/IDFA/OPENUDID/GUID、SIMカードIMSI情報）を収集して統計分析サービスを提供し、地理的位置較正レポートデータの正確性を通じて、基礎的な不正行為防止サービスを提供する必要があります。',
        p81: '（2）个推 SDK',
        p82: 'SDKを統合するには、プログラム携帯電話のデバイスプラットフォーム、デバイスメーカー、デバイスブランド、デバイスモデルおよびシステムバージョン、OAID、AndroidID、WIFI接続情報、キャリア情報を許可する必要があります。これにより、メッセージ送信の正確な発信とメッセージデバイスの正確な識別を保証することができます。',
        p83: '（3）Bugly SDK',
        p84: '当社の製品はBugly SDKを統合しており、Android携帯電話はあなたの携帯電話モデル、携帯電話ブランド、Androidシステムバージョン、Androidシステムapiクラス、メーカーシステムバージョン、cpuアーキテクチャタイプ、デバイスがrootされているかどうか、ディスク空間占有サイズ、sdcard空間占有サイズ、メモリ空間占有サイズ、ネットワークタイプ、アプリケーションが現在実行中のプロセス名、PIDを収集する必要があります。IOS携帯電話は、デバイスモデル、オペレーティングシステムバージョン、オペレーティングシステム内部バージョン番号、wifi状態、cpuプロパティ、メモリ空き領域、ディスク空間/ディスク空き領域、ランタイム携帯電話状態（プロセスが占めるメモリ、仮想メモリなど）、idfv、刑務所を越えるかどうか、地域コードを収集する必要があります。APPがバックグラウンドで実行中に異常が発生した場合、SDKはバックグラウンドでエンドユーザーの上記の個人情報を収集し、クラッシュ問題を調査処理することができます。',
        p85: 'ふろく：',
        p86: 'SDK統合と必要な権限リスト',
        p87: '友盟の統計',
        p88: 'ユーザーのアクティブ化などの運用データを統計するために必要',
        p89: 'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'READ_PHONE_STATE',
        p90: '个推',
        p91: 'メッセージ送信用',
        p92: 'INTERNET、' +
            'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'SCHEDULE_EXACT_ALARM、' +
            'BADGE_ICON、' +
            'READ_EXTERNAL_STORAGE、' +
            'WRITE_EXTERNAL_STORAGE、' +
            'READ_PHONE_STATE、' +
            'ネットワークアクセス権、' +
            'IDFA',
        p93: 'Bugly',
        p94: 'クラッシュ情報の収集に使用',
        p95: 'INTERNET、' +
            'ACCESS_NETWORK_STAT、' +
            'ネットワークアクセス権、',
        p96: '七、この宣言を更新する方法',
        p97: '私たちは本声明を適時に更新する権利を保留し、声明に変更が発生した場合、AppまたはWeChat公式アカウントプッシュ通知などの形式で変更後の声明をお見せします。お客様の同意を得た場合にのみ、更新された宣言に従って個人情報を収集、使用、保存します。',
        p98: 'この宣言は更新日から有効となります。',
        p99: '最終更新日：2024年6月6日',
        p100: '成都天奥電子株式会社',
        p101: '5、IPアドレス',
        p102: 'サーバを近くに割り当て、ユーザー全体の使用とアクセスを高速化するために、IPアドレスを収集します。',
        p103: '（4）PushReceiver SDK',
        p104: 'PushReceiver SDKは自己起動機能を備えており、本アプリケーションがオフまたはバックグラウンド運転状態で穴戸端プッシュを正常に受信できることを保証するために、機能とサービスの実現に必要なため、一定の周波数がシステム送信ブロードキャストを通じて本アプリケーションの自己起動または関連起動行為を起動することができる。本アプリケーションは、プッシュチャネルの安定性を確保し、正常かつタイムリーにアンドロイドデバイスにメッセージをプッシュするための（自己起動）能力を使用する必要があります。システムがブロードキャストを送信すると、PushReceiver SDKの自己起動動作が起動されます。PushReceiver SDK系が統合された方法でアプリケーションにアクセスしていることを考慮して、PushReceiver SDKが自起動すると、アプリケーションも自起動する。この行為はプッシュ機能とサービスを実現するために必要である。'
    },
    samSet: {
        title: '携帯電話のオープン権限が示す「制限された設定」の解決策',
        p0: 'このような状況はモトローラ、サムスンなどの携帯電話によく見られ、次の2つの方法で処理することができる。',
        p1: '方法一：',
        p2: '1、携帯電話のデスクトップでAswear APPのアイコンを長押しする＞アプリケーション情報＞右上の3点メニュー＞制限設定を許可する。',
        p3: '2、携帯電話「設定」>「通知」>「デバイスとアプリケーション通知」>「Aswear APPの選択」>「通知アクセス権の付与」に進む。',
        p4: '方法二：',
        p5: '以下はサムスン携帯電話の処理方式である：',
        p6: '1、携帯電話の設定>アプリケーション>その他のオプション（下図の3点）に進む',
        p7: '2、せんたく ',
        p8: '特別なアクセス',
        p9: '3、せんたく ',
        p10: 'アクセスの通知',
        p11: '4、Aswearを開く ',
        p12: '',
        p13: ''
    },
    water: {
        title: '水を飲む助手',
        time0: '日',
        time1: '周',
        time2: '月',
        time3: '年',
        math0: '最高',
        math1: '最低',
        today: '今日の飲用水量',
        surplus: '余剰',
        math2: '目標達成率',
        math3: '日平均最高',
        math4: '日平均最低',
        chartUnit: '日平均',
        descTitle: '水を飲むアドバイス',
        desc: '水は人体を構成する主要成分の一つであり、良好な健康状態を維持するためには、十分な水分摂取を確保することが必要である。それぞれの具体的なニーズは、年齢、性別、体重、活動レベル、環境によって異なります。通常、成人男性は1日2 ~ 3リットルの飲用水を推奨しているが、成人女性は1.5 ~ 2.5リットルで、具体的には個人の状況に応じて調整する必要がある。毎日時間通りに水を飲み、コップを使って水の量を追跡することは、健康的な水を飲む良い習慣を身につけるのに役立つ。',
        maxCountDesc: '飲水量が上限に達した~'
    },
    weight: {
        title: '体重記録',
        time0: '周',
        time1: '月',
        time2: '年',
        level0: '軽量',
        level1: '正常',
        level2: '過体重',
        level3: '肥満',
        desc0: 'BMI（Body Mass Index）は、体格指数とも呼ばれ、国際的に用いられる人間の肥満度と健康状態を測定するための一般的な基準です。計算式は：BMI = 体重 ÷ 身長²。（体重単位：キログラム；身長単位：メートル）。しかし、これは完璧なツールではなく、特に個体差が大きい場合の評価においては適していないことがあります。したがって、BMIを他の健康指標と組み合わせて使用することを推奨します、より包括的な健康評価を得るためです。',
        desc1: 'BMI範囲説明：<18.5 軽量；18.5~23.9 正常；24.0~29.9 過体重；>30 肥満。',
        change: '変化',
        popTitle: '記録今日の体重',
        height: '身長: ',
        heightPop: '身長'
    },
    planEdit: {
        title: '計画の編集',
        save: '保存',
        planName: '計画名',
        planNameDesc: '入力してください',
        action: 'アクション',
        actionAdd: 'アクションを追加',
        capacity: 'ようりょう',
        group: 'グループ化',
        weight: 'じゅうりょう',
        frequency: '回',
        distance: 'きょり',
        duration: '時間を使う',
        duration1: '時間を使う',
        common: '合',
        inputPlaceholder: '有効な必須項目を入力してください',
        actionListPlaceholder: '少なくとも1つのアクションを追加',
        success: '操作は成功しました！'
    },
    actionLibrary: {
        title: 'アクションライブラリ',
        searchDesc: '入力してください',
        action1: '全身',
        action2: '肩と首',
        action3: '腕',
        action4: '胸',
        action5: '背中',
        action6: '腰と腹',
        action7: 'お尻と脚',
        action8: 'カスタム',
        confirm: '確認',
        customize: 'カスタムアクション',
        customizeDesc: '独自のアクションを作成する',
        instrument1: '徒手',
        instrument2: 'ダンベルベンチ',
        instrument3: 'ベンチプレスベンチ',
        instrument4: '竜門棚',
        instrument5: '懸垂機',
        instrument6: 'スイスボール',
        instrument7: '弾性紐',
        instrument8: '仰臥板',
        instrument9: 'バーベルベンチ',
        instrument10: 'ハックスクワットマシン',
        instrument11: 'レッグプレスマシン',
        instrument12: '縄跳び',
        instrument13: 'ロープマシン',
        instrument14: '牧師の腰掛け',
        instrument15: 'ヘキサゴンバーベル',
        instrument16: '脚曲げ機',
        instrument17: 'バーベル本',
        instrument18: '亜鈴',
        instrument19: '座り踵取り機',
        instrument20: '高位置プルダウン機',
        instrument21: 'Tバーベル',
        instrument22: 'スミスマシン',
        instrument23: '腹巻き機',
        instrument24: 'その他',
        instrument25: '縄',
        muscles1: '斜方筋',
        muscles2: '大胸筋',
        muscles3: '上腕二頭筋',
        muscles4: '上腕三頭筋',
        muscles5: '前腕筋群',
        muscles6: '広背筋',
        muscles7: '脊柱起立筋',
        muscles8: '臀筋',
        muscles9: '大腿後筋群',
        muscles10: '腹筋',
        muscles11: '大腿四頭筋',
        muscles12: '内転筋',
        muscles13: '外転筋',
        muscles14: '下腿筋群',
        muscles15: '三角筋',
        detailBtn: '紹介'
    },
    actionDesc: {
        title: 'アクションの詳細',
        part: '訓練部位',
        point: '動作の要点',
        delete: '削除'
    },
    actionEdit: {
        title: 'アクション編集',
        actionName: 'アクション名',
        actionNamePlaceholder: '動作名を入力してください',
        actionPart: '訓練部位',
        actionPartPlaceholder: 'トレーニング部位を選択してください',
        actionInstrument: '訓練器具',
        actionInstrumentPlaceholder: 'トレーニング機器をお選びください',
        recordType: 'レコードデータ',
        recordTypePlaceholder: 'レコードデータを選択してください',
        actionBanner: 'アクションカバー',
        actionBannerPlaceholder: 'アクションカバーをアップロードしてください',
        actionMuscles: '訓練筋群',
        actionMusclesPlaceholder: 'トレーニング筋群を選択してください',
        actionPoint: '動作の要点',
        actionPointPlaceholder: '動作の要点を入力してください',
        save: '保存',
        selectPlaceholder: '選択してください',
        recordType1: '荷重と回数',
        recordType2: '時間のみ',
        recordType3: '回数のみ',
        recordType4: '距離のみ',
        pointPlaceholder: 'この動作の正しい姿勢、技術的なポイント、注意事項を説明することができます。',
        delete: 'アクションの削除',
        deleteTitle: '削除のヒント',
        deleteDesc: '本当にアクションを削除しますか？',
        confirm: '確認',
        cancel: 'キャンセル'
    },
    setPlanDate: {
        title: '訓練日の設定',
        repeatWeek: 'くりかえし',
        startDate: '開始時間',
        endDate: '終了時間',
        week0: '月',
        week1: '火',
        week2: '水',
        week3: '木',
        week4: '金',
        week5: '土',
        week6: '日',
        confirm: '確認',
        cancel: 'キャンセル',
        repeatTips: '少なくとも1つの繰り返し期間を選択してください',
        repeatText: '',
        repeatText0: '月',
        repeatText1: '火',
        repeatText2: '水',
        repeatText3: '木',
        repeatText4: '金',
        repeatText5: '土',
        repeatText6: '日',
        repeatText7: '毎日',
        repeatTextSplit: '、',
        import: 'トレーニングカレンダーにインポート',
        isRemind: 'リマインダの設定',
        remindTime: 'リマインダ時間',
        planErrorMsg: '計画は存在しません。再試行を終了してください'
    },
    planLibrary: {
        title: '計画ライブラリ',
        history: '履歴計画',
        create: '+作成',
        progress: '進行中',
        group: 'グループ化',
        capacity: 'ようりょう',
        action: 'アクション',
        groupCount: 'グループ化'
    },
    planDesc: {
        title: '計画の詳細',
        start: '訓練を開始する',
        edit: '編集',
        delete: '削除',
        out: '終了',
        outPlan: '計画を終了する',
        outPlanDesc: 'トレーニング計画を終了しても、前の運動記録をクリアせず、終了を確認しますか？',
        confirm: '確認',
        cancel: 'キャンセル',
        deleteTitle: 'リマインダの削除',
        deleteDesc: '現在の計画は進行中です。現在の計画を停止して削除しますか？',
        success: '削除に成功しました！'
    },
    trainCalendar: {
        title: 'カレンダ',
        seeDetail: '詳細の表示'
    },
    startTrain: {
        title: '訓練を開始する',
        finish: '完了',
        action: 'アクション',
        group: 'グループ化',
        capacity: 'ようりょう',
        rest: '休憩',
        duration: 'タイミング',
        startTiming: '開始',
        feel: 'トレーニング感覚',
        confirm: '確認',
        easy: 'ゆとりがある',
        normal: 'ちょうどよい',
        hard: '困難',
        feelInput: '今日のトレーニングの心得と注意すべきことを書いてください'
    },
    sportTrainDesc: {
        title: '運動の詳細',
        rest: '休憩時間',
        cal: '運動エネルギー消費',
        hr: '心拍数',
        hrUnit: 'bpm',
        max: '最高',
        min: '最小',
        avg: '平均',
        hrRange0: 'きょくげん区間',
        hrRange1: '無酸素区間',
        hrRange2: '持久力区間',
        hrRange3: '有酸素区間',
        hrRange4: 'ウォーミングアップ区間',
        trainEffect: 'トレーニング効果',
        trainFeel: 'トレーニング感覚',
        trainParts: '訓練部位',
        effect0: 'ふくげんりょく',
        effect1: 'ばくはつりょく',
        effect2: '持久力',
        effect3: 'パワー',
        effect4: '経済性',
        dataFrom: 'データは '
    }
};

export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/ja.js